import axios, { AxiosInstance } from 'axios';

export const API_ROOT = process.env.REACT_APP_API;

const api: AxiosInstance = axios.create({
  baseURL: API_ROOT
});

let authTokenRequest: any;

const resetAuthTokenRequest = () => {
  authTokenRequest = null;
};

const getRefreshToken = async (logout: () => void) => {
  const refreshToken = localStorage.getItem('cpcRefresh');
  try {
    const { data } = await api.post(
      '/auth/refresh',
      {
        refreshToken
      },
      {
        headers: {
          grant_type: 'refresh_token'
        }
      }
    );

    localStorage.setItem('cpcToken', data.token);
    localStorage.setItem('cpcRefresh', data.refresh);

    return data;
  } catch (error) {
    logout();
    return Promise.reject(error);
  }
};
// This function makes a call to get the auth token
// or it returns the same promise as an in-progress call to get the auth token
export const getAuthToken = (logout: () => void) => {
  if (!authTokenRequest) {
    authTokenRequest = getRefreshToken(logout);
    authTokenRequest.then(resetAuthTokenRequest, resetAuthTokenRequest);
  }

  return authTokenRequest;
};

export const requestInterceptor = (config: any) => {
  const token = localStorage.getItem('cpcToken');
  if (token) config.headers['Authorization'] = `${token}`;
  return config;
};

export const interceptorError = (error: any) => {
  return Promise.reject(error);
};

api.interceptors.request.use(requestInterceptor, interceptorError);

export default api;
